module.exports = __webpack_public_path__ + "img/226e2f0.png";